import { useEffect, useState } from 'react';
import adminAPI from '../services/adminApi';

/**
 * Location names by id (locations live in the admin service; finance stores only their ids).
 * Loaded once per page session and shared by every caller.
 */
let cache = null;

export const loadLocationNames = () => {
  if (!cache) {
    cache = adminAPI.getLocations({ limit: 500 })
      .then(r => Object.fromEntries((r.data?.data || []).map(l => [String(l._id), l.name])))
      .catch(() => { cache = null; return {}; });
  }
  return cache;
};

/** { [locationId]: name } — empty until loaded */
export const useLocationNames = () => {
  const [names, setNames] = useState({});
  useEffect(() => {
    let alive = true;
    loadLocationNames().then(n => { if (alive) setNames(n); });
    return () => { alive = false; };
  }, []);
  return names;
};

/** Distinct location names of a journal's lines (falls back to its header location) */
export const journalLocations = (txn, names) => {
  const ids = [...new Set((txn?.lines || []).map(l => l.location && String(l.location)).filter(Boolean))];
  if (!ids.length && txn?.location) ids.push(String(txn.location));
  return ids.map(id => names[id] || 'Unknown location');
};
